import * as tslib_1 from "tslib";
import React from 'react';
import _ from 'lodash';
import { useLocalize } from '../../../hooks';
import { Text } from '../';
import { TextboxInput } from '../../fields';
export const DEFAULT_WIDTH = 1200;
export const DEFAULT_SMALL_COL = 2;
export const DEFAULT_MEDIUM_COL = 4;
export const DEFAULT_LARGE_COL = 6;
export const TextboxField = (_a) => {
    var { field, form, id, label, labelPrefix, isPercentage, suppressError } = _a, rest = tslib_1.__rest(_a, ["field", "form", "id", "label", "labelPrefix", "isPercentage", "suppressError"]);
    const { defaultLabelId, errorAfterSubmit } = rest;
    const { values, errors, touched, submitCount } = form;
    const value = _.get(values, id);
    const error = _.get(touched, id) ? _.get(errors, id) : undefined;
    const { getFieldTranslationId } = useLocalize();
    // showError will only show errors when field is touched or after submit if errorAfterSubmit is true
    // But suppress error display if suppressError prop is true
    const showError = suppressError ? false : (errorAfterSubmit ? !!submitCount : !!_.get(touched, id));
    const formatValue = (value) => {
        if (field.value < 1) {
            if (field.name.toLowerCase() === 'width')
                return DEFAULT_WIDTH.toString();
            if (field.name.toLowerCase() === 'gridColumnsLarge')
                return DEFAULT_LARGE_COL.toString();
            if (field.name.toLowerCase() === 'gridColumnsMedium')
                return DEFAULT_MEDIUM_COL.toString();
            if (field.name.toLowerCase() === 'gridColumnsSmall')
                return DEFAULT_SMALL_COL.toString();
            // This will handle cases where value could be 0 and avoid default values from overwriting it.
            return value;
        }
        else {
            return value;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TextboxInput, Object.assign({ name: id, label: label || (React.createElement(Text, { id: getFieldTranslationId({ id, defaultLabelId }), type: "field", data: labelPrefix && { prefix: labelPrefix } })), value: formatValue(value), error: error, onblur: field.onBlur, onchange: field.onChange, autoComplete: rest.autoComplete || id }, rest)),
        error && showError && (React.createElement("span", { className: "error" },
            React.createElement(Text, { id: id, textKey: `${error}`, type: 'error', data: rest.data })))));
};
//# sourceMappingURL=Textbox.js.map